import cn from 'classnames';
import React from 'react';

import {AppButton} from '@/components/Button';
import RemoteIcon from '@/components/Icon/RemoteIcon';
import appConfig from '@/config/appConfig.typed';
import * as localizationKeys from '@/consts/localization/localizationKeys';
import useConfigExternalLink from '@/hooks/externalLink/useConfigExternalLink';
import {getAriaLabel} from '@/services/accessibilityService';
import amplitudeDeviceTracking from '@/services/analytics/amplitude/amplitudeDeviceTracking';
import googleAnalyticsService from '@/services/analytics/ga/googleAnalyticsService';
import {getLocalizedStrings} from '@/services/localization/localizationService';
import stringUtils from '@/utils/stringUtils';
import uaUtils from '@/utils/uaUtils';

const MyDevicesGoToChromeMessage = () => {
    const localizedStrings = getLocalizedStrings();
    const browserName = uaUtils.getBrowserName();

    const topText = stringUtils.formatString(
        localizedStrings[localizationKeys.MY_DEVICES_PAGE_CONNECT_BROWSER_NOT_TRUSTED_TEXT_1],
        browserName
    );
    const bottomText = localizedStrings[localizationKeys.MY_DEVICES_PAGE_CONNECT_BROWSER_NOT_TRUSTED_TEXT_2];

    const downloadChromeUrl = appConfig.getDownloadChromeUrl();
    const {redirectToExternalLink} = useConfigExternalLink({...downloadChromeUrl});

    const onClick = () => {
        amplitudeDeviceTracking.trackChromeDownloadButtonClick();
        googleAnalyticsService.trackChromeDownloadButtonClick();
        redirectToExternalLink();
    };

    if (!topText && !bottomText) return null;

    const icon = appConfig.getDevicesInfoIcon();
    const buttonText = localizedStrings[localizationKeys.MY_DEVICES_PAGE_CONNECT_GO_TO_TRUSTED_BROWSER_BUTTON];

    return (
        <div className='flex w-full flex-col gap-4.5 rounded-xl bg-romance p-4 ml:mt-2'>
            <div className={cn('flex gap-2', (!topText || !bottomText) && 'items-center')}>
                <div className='p-1.5'>
                    <RemoteIcon icon={icon} className='h-9 w-9' />
                </div>
                <div className='flex flex-col'>
                    {topText && <p className='text-16 font-bold leading-15 tracking-02'>{topText}</p>}
                    {bottomText && <p className='text-14 leading-143 tracking-04'>{bottomText}</p>}
                </div>
            </div>
            {buttonText && (
                <AppButton
                    className='m-0 w-full shrink-0'
                    primary
                    light
                    onClick={onClick}
                    aria-label={getAriaLabel(
                        localizationKeys.MY_DEVICES_PAGE_CONNECT_GO_TO_TRUSTED_BROWSER_BUTTON_ARIA_LABEL
                    )}
                >
                    {buttonText}
                </AppButton>
            )}
        </div>
    );
};

export default MyDevicesGoToChromeMessage;
